export default "__VITE_ASSET__mBpb0pLW__"